<template>
  <div>
    <b-modal
        :title="$t('Send join meeting request')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        no-close-on-backdrop>
      <form @submit.prevent="send()">
        <b-form-group>
          <b-input-group class="input-group-trans">
            <b-form-input v-model="transId" :placeholder="$t('Enter a TranS ID')" readonly/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-id.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-form-group v-if="schedules.length > 1">
          <b-select v-model="formData.scheduleId" class="input-trans calendar">
            <option v-for="(s, i) in schedules" :key="i" :value="s.ScheduleID">
              {{ s.Name }}
            </option>
          </b-select>
        </b-form-group>

        <b-form-group class="mb-0">
          <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary">
            {{
              $t("Send request")
            }}
          </b-button>
        </b-form-group>
      </form>
    </b-modal>
    <PanelLoading :show="loading" message="Sending request"/>
  </div>
</template>

<script>
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "AddJoinRequestModal",
  data: function () {
    return {
      loading: false,
      show: false,
      schedule: null,
      schedules: [],
      transId: "",
      formData: {
        scheduleId: ""
      }
    }
  },
  methods: {
    open: function (transId, schedules, schedule) {
      this.transId = transId;
      this.schedule = schedule;
      this.schedules = schedules;
      if (schedule)
        this.formData.scheduleId = schedule.ScheduleID;

      this.show = true;
    },
    send: async function () {
      if (this.loading)
        return;

      this.loading = true;
      const response = await meetingService.sendJoinRequest({
        id: this.formData.scheduleId,
        transId: this.transId
      });
      this.loading = false;

      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      this.show = false;
      dialogHelper.alert(response.substr(3), "success");
    }
  }
}
</script>

<style scoped>

</style>